import React, { useState } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { TID } from "@/lib/testIds";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", category: "general", message: "", consent: false });
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent) { toast.error("Please provide consent to be contacted."); return; }
    try {
      await api.post("/support/contact", form);
      setSubmitted(true);
      toast.success("Message received. We'll be in touch shortly.");
    } catch { toast.error("Something went wrong. Please try again."); }
  };

  return (
    <div className="App min-h-screen">
      <Navbar />
      <section className="section">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 grid md:grid-cols-5 gap-12">
          <div className="md:col-span-2">
            <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-3">Contact</div>
            <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-6">Get in touch.</h1>
            <div className="text-sm text-muted-foreground space-y-2 leading-relaxed">
              <p><span className="font-mono uppercase text-[11px] tracking-widest-2 block text-foreground/60">Email</span>support@exactreach.example</p>
              <p><span className="font-mono uppercase text-[11px] tracking-widest-2 block text-foreground/60 mt-4">Hours</span>Mon–Fri, 9:00–18:00 GMT</p>
              <p><span className="font-mono uppercase text-[11px] tracking-widest-2 block text-foreground/60 mt-4">Address</span>ExactReach Ltd.<br/>42 Data Lane<br/>London, UK</p>
            </div>
          </div>
          <div className="md:col-span-3">
            {submitted ? (
              <div className="border border-emerald-200 bg-emerald-50 text-emerald-900 p-6 rounded-sm">
                <div className="font-semibold mb-1">Thanks — we received your message.</div>
                <p className="text-sm">Our team will respond within 1 business day.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4 border border-border p-6 bg-white">
                <div>
                  <Label htmlFor="c-name">Your name</Label>
                  <Input id="c-name" data-testid={TID.contact.name} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" />
                </div>
                <div>
                  <Label htmlFor="c-email">Work email</Label>
                  <Input id="c-email" required type="email" data-testid={TID.contact.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" />
                </div>
                <div>
                  <Label>Request category</Label>
                  <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
                    <SelectTrigger data-testid={TID.contact.category} className="mt-1"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="general">General enquiry</SelectItem>
                      <SelectItem value="audience">Audience request question</SelectItem>
                      <SelectItem value="pricing">Pricing question</SelectItem>
                      <SelectItem value="partnership">Partnership</SelectItem>
                      <SelectItem value="other">Other</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label htmlFor="c-msg">Message</Label>
                  <Textarea id="c-msg" required data-testid={TID.contact.message} rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1" />
                </div>
                <label className="flex items-start gap-3 text-sm">
                  <Checkbox data-testid={TID.contact.consent} checked={form.consent} onCheckedChange={(v) => setForm({ ...form, consent: !!v })} className="mt-0.5" />
                  <span>I consent to being contacted by ExactReach in relation to this enquiry.</span>
                </label>
                <Button type="submit" data-testid={TID.contact.submit} className="rounded-sm w-full h-11">Send message</Button>
              </form>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
